// src/router/AdminRouter.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AdminLayout, AdminLayoutTop } from "../layouts";
import {
  Page_Teacher_Salas_free,
  PageTeacherFreeAssistant,
  PageTeacherFreeQuiz,
  PageTeacherFreeEducamaker,
  PageTeacherFreeEvaluation,
} from "../pages/portal";
import { ForgotPasswordForm , ResetPasswordForm } from "../components/Admin/Auth";
import {
  Auth,
  AuthTeacherstudents,
  Page_Partner_Profile,
  Page_Partner_Institution,
  Page_Partner_Facturation,
  Page_Support_Partner,
  Page_Institution_Profile,
  Page_Institution_Class,
  Page_Institution_Teacher,
  Page_Institution_Student,
  Page_Institution_Support,
  Page_Institution_Facturation,
  Page_Teacher_Salas,
  Page_Teacher_evalucacion,
  VirtualScenes,
  Page_Teacher_Quiz,
  Page_Guia,
  PageStudentsHome,
  Page_UserFreeSalas,
  Page_UIMaterials,
  Page_Assistant,
  AuthPartner,
} from "../pages/portal";
import { useAuth } from "../hooks";

export function AdminRouter() {
  const { user } = useAuth();

  //if (user === null) return null;
  let role = user?.user?.role; // p.ej. "admin", "teacher", etc.
  if (role === "teacher" && user?.user?.account === "free") {
    role = "teacherfree";
  }

  // Función para inyectar un Page dentro de un Layout
  const loadLayout = (Layout, Page) => (
    <Layout>
      <Page />
    </Layout>
  );

  // Rutas específicas según el rol
  const roleRoutes = {
    admin: [
      {
        path: "register",
        element: loadLayout(AdminLayout, Page_Partner_Profile),
      },
      {
        path: "institution",
        element: loadLayout(AdminLayout, Page_Partner_Institution),
      },
    ],
    teacher: [
      {
        path: "teacher/salas",
        element: loadLayout(AdminLayout, Page_Teacher_Salas),
      },
      {
        path: "teacher/assistant",
        element: loadLayout(AdminLayout, Page_Assistant),
      },
      {
        path: "teacher/evaluacion",
        element: loadLayout(AdminLayout, Page_Teacher_evalucacion),
      },
      {
        path: "teacher/educamaker",
        element: loadLayout(AdminLayout, VirtualScenes),
      },
      {
        path: "teacher/quiz",
        element: loadLayout(AdminLayout, Page_Teacher_Quiz),
      },
      {
        path: "teacher/guia/:id",
        element: loadLayout(AdminLayout, Page_Guia),
      },
    ],
    teacherfree: [
      {
        path: "teacherfree/salas",
        element: loadLayout(AdminLayout, Page_Teacher_Salas_free),
      },
      {
        path: "teacherfree/assistant",
        element: loadLayout(AdminLayout, PageTeacherFreeAssistant),
      },
      {
        path: "teacherfree/evaluacion",
        element: loadLayout(AdminLayout, PageTeacherFreeEvaluation),
      },
      {
        path: "teacherfree/educamaker",
        element: loadLayout(AdminLayout, PageTeacherFreeEducamaker),
      },
      {
        path: "teacherfree/quiz",
        element: loadLayout(AdminLayout, PageTeacherFreeQuiz),
      },
      {
        path: "teacherfree/educamakerfree",
        element: loadLayout(AdminLayout, PageTeacherFreeEducamaker),
      },
      {
        path: "teacherfree/guia/:id",
        element: loadLayout(AdminLayout, Page_Guia),
      },
    ],
    student: [
      {
        path: "student/home",
        element: loadLayout(AdminLayoutTop, PageStudentsHome),
        //element:  <PageStudentsHome />,
      },
    ],
    institution: [
      {
        path: "inst/profile",
        element: loadLayout(AdminLayout, Page_Institution_Profile),
      },
      {
        path: "inst/class",
        element: loadLayout(AdminLayout, Page_Institution_Class),
      },
      {
        path: "inst/teachers",
        element: loadLayout(AdminLayout, Page_Institution_Teacher),
      },
      {
        path: "inst/students",
        element: loadLayout(AdminLayout, Page_Institution_Student),
      },
      {
        path: "inst/facturation",
        element: loadLayout(AdminLayout, Page_Institution_Facturation),
      },
      {
        path: "inst/support",
        element: loadLayout(AdminLayout, Page_Institution_Support),
      },
    ],
    partner: [
      {
        path: "partner/register",
        element: loadLayout(AdminLayout, Page_Partner_Profile),
      },
      {
        path: "partner/institution",
        element: loadLayout(AdminLayout, Page_Partner_Institution),
      },
      {
        path: "partner/facturation",
        element: loadLayout(AdminLayout, Page_Partner_Facturation),
      },
      {
        path: "partner/support",
        element: loadLayout(AdminLayout, Page_Support_Partner),
      },
    ],
    user: [
      {
        path: "userfree/salas",
        element: loadLayout(AdminLayout, Page_UserFreeSalas),
      },
      {
        path: "userfree/guia/:id",
        element: loadLayout(AdminLayout, Page_Guia),
      },
    ],
    // Podrías definir student, user, etc.
  };

  // Ruta por defecto según el rol
  const defaultPathByRole = {
    admin: "portal/register",
    partner: "portal/partner/register",
    institution: "portal/inst/profile",
    teacher: "/portal/teacher/salas",
    teacherfree: "/portal/teacherfree/salas",
    student: "portal/student/home",
    user: "userfree/salas",
  };

  // Se eligen las rutas según el rol de user
  const availableRoutes = roleRoutes[role] || [];
  // Si no existe coincidencia, fallback a "auth"
  const defaultPath = defaultPathByRole[role] || "auth";

  return (
    <Routes>
      {/* Ruta accesible sin user */}
      <Route path="/auth-institution" element={<AuthTeacherstudents />} />

      {/* Si no hay user => rutas públicas (Auth) */}
      {!user ? (
        <>
          {/* Ruta normal de login */}
          <Route path="/auth" element={<Auth />} />
            {/* Recuperación y restablecimiento */}
          <Route
            path="/recuperar-contraseña"
            element={<ForgotPasswordForm />}
          />
          <Route
            path="/reset-password"
            element={<ResetPasswordForm />}
          />
          <Route
            path="/partner/auth"
            element={<AuthPartner />}
          />
          {/* Cualquier otra ruta sin user => redirige a /auth */}
          <Route path="*" element={<Navigate to="/auth" />} />
        </>
      ) : (
        <>
          {/* Rutas definidas para este rol */}
          {availableRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

          {/* Ruta para materiales UI */}
          <Route
            path="materials"
            element={loadLayout(AdminLayout, Page_UIMaterials)}
          />

           {/* Al acceder a /portal/ (el “index”), vamos al defaultPath */}
          <Route
            index
            element={<Navigate to={defaultPath} replace />}
          />

          {/* Cualquier otra ruta inválida → al mismo defaultPath */}
          <Route
            path="*"
            element={<Navigate to={defaultPath} replace />}
          />
        </>
      )}
    </Routes>
  );
}
